<template>
	<div>
		<v-container fluid :style="'height: 100vh;background-color:' + $theme.primary">
			<v-layout fill-height>
				<v-row align="center">
					<v-col align="center">
						<v-sheet class="mx-auto" style="width: 400px; padding: 50px" outlined rounded="xl">
							<h3 :style="'color:' + $theme.primary">
								진담헤어
							</h3>
							<br />
							<br />
							<v-btn color="primary" @click="onClickDownload">
								어플 다운받기
							</v-btn>
						</v-sheet>
					</v-col>
				</v-row>
			</v-layout>
		</v-container>
	</div>
</template>

<script>
	export default {
		mounted() {
			var isAndroid = /android/i.test(navigator.userAgent);
			var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
			if (isAndroid) {
				location.href = 'https://play.google.com/store/apps/details?id=com.flynnapps.jindamhair';
			} else if (isiOS) {
				location.href = 'https://apps.apple.com/app/1619262794';
			} else {
				console.log('not android & ios');
				location.href = 'https://play.google.com/store/apps/details?id=com.flynnapps.jindamhair';
			}
		},
	};
</script>

<style scoped></style>
